import { publicAssetUrl } from '@maxus/website/constants'
import { cn } from '@maxus/website/utils'

type VideoThumbProps = {
  className?: string
  compact?: boolean
  // 封面图 URL：给定时渲染 <img> 等比填满容器（object-cover，宽或高撑满、裁切溢出）；缺省回退到静态占位图。
  src?: string | null
}

export const VideoThumb = ({ className, compact, src }: VideoThumbProps) => {
  const sizeClass = compact ? 'h-11 w-[62px]' : 'h-20 w-28'

  if (src) {
    return (
      <div className={cn('overflow-hidden rounded bg-[#05070b]', sizeClass, className)}>
        <img alt="" className="h-full w-full object-cover" loading="lazy" src={src} />
      </div>
    )
  }

  return (
    <div className={cn('overflow-hidden rounded bg-[#60757c]', sizeClass, className)}>
      <img
        alt=""
        className="h-full w-full object-cover"
        loading="lazy"
        src={publicAssetUrl('video-cover-placeholder.svg')}
      />
    </div>
  )
}
